export default __webpack_public_path__ + "static/media/error.c7a15e2b.png";